import { render, staticRenderFns } from "./giveaways.vue?vue&type=template&id=52976931"
import script from "./giveaways.vue?vue&type=script&lang=js"
export * from "./giveaways.vue?vue&type=script&lang=js"
import style0 from "./giveaways.vue?vue&type=style&index=0&id=52976931&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports